import React, {useCallback, useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {UserService} from "./user.service";
import {changePageTitle} from "../typescript/redux/actions";
import {Datatable} from "../index";
import {Delete} from "@mui/icons-material";
import {useNavigate, useParams} from "react-router-dom";

export function VacationList() {

    const {id} = useParams();

    let navigate = useNavigate();
    const [pageParams, setPageParams] = useState(null);
    const dispatch = useDispatch();

    const findAll = useCallback(async (number, size, sort) => {
        const items = await UserService.findAllVacations(id, number, size, sort);
        setPageParams({
            number: number,
            size: size,
            sort: sort,
            items: items
        });
    }, [id]);

    useEffect(() => {
        dispatch(changePageTitle("Férias do usuário " + id));
        findAll(0, parseInt(process.env.REACT_APP_PAGE_SIZE), "id,asc").then();
    }, [dispatch, findAll, id]);

    const editItem = (item) => {
        navigate('/user/' + id + '/vacation/' + item.id);
    }

    const insertItem = () => {
        navigate('/user/' + id + '/vacation');
    }

    const goBack = () => {
        navigate('/users');
    }

    const deleteItem = (item) => {
        UserService.deleteVacation(id, item.id).then(() => {
            findAll(pageParams.number, pageParams.size, pageParams.sort).then();
        }).catch(() => {

        })
    }

    const headerOperations = [
        {onClick: goBack, label: () => 'Voltar'},
        {color: () => "primary", onClick: insertItem, label: () => 'Inserir'}
    ]

    const rowOperations = [
        {color: () => "primary", onClick: deleteItem, label: () => 'Excluir', icon: () => <Delete/>},
    ]

    return pageParams && (
        <Datatable data={pageParams.items.content} totalData={pageParams.items.totalElements}
                   number={pageParams.number} size={pageParams.size} sort={pageParams.sort} filter={pageParams.filter}
                   findAll={findAll}
                   dataColumnNames={['Início', 'Fim']}
                   dataColumns={['start', 'end']}
                   dataTypes={['date', 'date']}
                   editData={editItem} headerOperations={headerOperations} rowOperations={rowOperations}/>
    );
}